const logoPaginaDofollow = 'Logo en la página del programa en TNO Network (sección Anunciantes) con enlace dofollow.';

const optionsData = [
  {
    title: 'Sponsorship Hablemos de Todo',
    annualPrice: 'Trimestral: 360',
    monthlyPrice: 120,
    features: [
      'Tres menciones en vivo: al entrar, en el desarrollo (aquí se explica tu marca) y salida',
      'Video comercial de 20 segundos durante el programa',
      'Presencia en transmisión en vivo por TNO Network',
      'Presencia en Web, App y Redes Sociales',
      'Asociación con conversación de valor, bienestar y desarrollo personal',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas de bienestar, educación, salud, consumo y servicios profesionales.',
    duration: 'Mensual',
    buttonText: 'Patrocinar Hablemos de Todo',
    highlightedTitle: 'Confianza con audiencia adulta',
    highlightedContent: [
      'Tu marca viaja con el tono cercano de Janeth Cano.',
      'Tres menciones + un comercial de 20 segundos dentro del programa.',
      'Relaciones, liderazgo y bienestar en un solo espacio.',
    ],
    highlightedButtonText: 'Ver Demo del Programa',
  },
  {
    title: 'Segmento Exclusivo por Tema',
    annualPrice: 'Trimestral: 180',
    monthlyPrice: 60,
    features: [
      'Mención exclusiva: "Este segmento presentado por..."',
      'Vinculación con una temática: Relaciones, Liderazgo, Bienestar o Desarrollo personal',
      'Contenido alineado con el ADN de tu marca',
      'Presencia en el bloque correspondiente del programa',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas que buscan relevancia temática con audiencia adulta activa.',
    duration: 'Suscripción Mensual',
    buttonText: 'Elegir mi Tema',
    highlightedTitle: 'Liderazgo de categoría',
    highlightedContent: [
      'Tu marca se convierte en referente del segmento elegido.',
      'Asociación orgánica con una audiencia que busca herramientas prácticas.',
      'Ideal para salud, educación y marcas de transformación personal.',
    ],
    highlightedButtonText: 'Ver Temas Disponibles',
  },
  {
    title: 'Entrevista Patrocinada',
    annualPrice: 'Por sesión: 40',
    monthlyPrice: 40,
    features: [
      'Entrevista de 20 minutos en vivo',
      'Proyección de tus videos promocionales',
      'Mención de sedes, servicios o puntos de contacto',
      'Propuesta con respaldo visual en pantalla',
      'Post en redes sociales del programa',
      logoPaginaDofollow,
    ],
    idealFor: 'Especialistas, emprendedores, marcas personales y voceros de empresas.',
    duration: '20 minutos por sesión',
    buttonText: 'Agendar Entrevista',
    highlightedTitle: 'Tu historia en antena',
    highlightedContent: [
      'Proyección de videos promocionales durante la entrevista.',
      'Narrativa de marca con tono cercano de Hablemos de Todo.',
    ],
    highlightedButtonText: 'Consultar Fechas',
  },
  {
    title: 'Post Patrocinado en TNO Digest',
    annualPrice: 'Por publicación: 50',
    monthlyPrice: 50,
    features: [
      'Publicación patrocinada en las redes sociales de TNO Digest',
      'Alcance en el ecosistema digital de Hablemos de Todo y TNO Digest',
      'Contenido adaptado a audiencias interesadas en bienestar y crecimiento',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas que buscan visibilidad en redes sin compromiso de programa en vivo.',
    duration: 'Por publicación',
    buttonText: 'Solicitar Post Patrocinado',
    highlightedTitle: 'Visibilidad en TNO Digest',
    highlightedContent: [
      'Tu marca en el feed oficial de TNO Digest.',
      'Ideal para lanzamientos o reforzar campañas de posicionamiento.',
    ],
    highlightedButtonText: 'Solicitar Post',
  },
  {
    title: 'Cápsula de Marca / Experiencia',
    annualPrice: 'Pack 5 Cápsulas: 150',
    monthlyPrice: 40,
    features: [
      'Cápsula de 60-90 segundos con estética del programa',
      'Distribución en redes sociales de TNO y del programa',
      'Tema: relaciones, bienestar, liderazgo o promoción de servicios',
      'Locución profesional en línea con el tono del show',
      logoPaginaDofollow,
    ],
    idealFor: 'Promociones de servicios, eventos, lanzamientos y campañas de marca.',
    duration: 'Por cápsula',
    buttonText: 'Solicitar Cápsula',
    highlightedTitle: 'Atención en Redes',
    highlightedContent: [
      'Tu mensaje en el ecosistema de Hablemos de Todo.',
      'Formato breve y memorable para máxima recordación.',
    ],
    highlightedButtonText: 'Enviar mi Propuesta',
  },
  {
    title: 'UGC de Testimonio',
    annualPrice: '80 por pieza',
    monthlyPrice: 80,
    features: [
      'Video estilo testimonio o experiencia con el producto',
      'Demostración en contexto cotidiano y auténtico',
      'Narrativa humana alineada con el tono del programa',
      'Publicación del video en TNO y en Hablemos de Todo',
      'Entrega de archivo original para pauta publicitaria de la marca',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas de consumo, bienestar y servicios que buscan prueba social auténtica.',
    duration: 'Por pieza',
    buttonText: 'Activar Campaña UGC',
    highlightedTitle: 'Prueba social auténtica',
    highlightedContent: [
      'Contenido UGC con tono del programa y credibilidad de Janeth Cano.',
      'Tu marca como recomendación de un par, no como anuncio frío.',
    ],
    highlightedButtonText: 'Activar Campaña UGC',
  },
];

export default optionsData;
